const colorList = [
  '#85F4FF', '#D9F8C4', '#CCD6A6', '#FFB4B4', '#CEE5D0', '#C7D36F', '#C6DCE4', '#F9CEEE'
]
export const stringToHexCode = (name) => {
  let sum = 0
  for (let i = 0; i < name.length; i++) {
    sum += name.charCodeAt(i)
  }
  return colorList[Math.floor(sum % colorList.length)]
}

export default stringToHexCode
